import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import { hot } from 'react-hot-loader';
import { Row, Col, ModalBody, ModalFooter, Button } from 'reactstrap';
import { FormattedMessage } from 'react-intl';

import { APPLICATION_ROOT } from '../../constants';
import { CenteredModal, SubmitButton } from '..';

const ExitConfirmationModal = (props) => {
  const {
    closeConfirmationModal,
    confirmationModalIsOpen,
    title,
    message,
    cancelText,
    discardText,
    submittingText,
  } = props;
  return (
    <Fragment>
      <CenteredModal
        style={{ margin: '20rem auto', maxWidth: '450px' }}
        isOpen={confirmationModalIsOpen}
        parentselector={APPLICATION_ROOT}
        toggle={() => {}}
        backdrop
      >
        <ModalBody className="p-4" style={{ overflowY: 'auto' }}>
          <div className="modal-header pt-0 pb-4 mx-n4 px-4">
            <div className="font-weight-light h4 mb-0">
              <div className="d-inline pl-1"><FormattedMessage id={title} /></div>
            </div>
          </div>
          <Row className="pt-4">
            <Col>
              <FormattedMessage id={message} />
            </Col>
          </Row>
        </ModalBody>
        <ModalFooter>
          <Button className="mr-3" color="default" onClick={() => closeConfirmationModal(false)}>
            <FormattedMessage id={cancelText} />
          </Button>
          <SubmitButton
            onSubmit={() => closeConfirmationModal(true)}
            defaultLabel={discardText}
            submittingLabel={submittingText || discardText}
            submitting={false}
            disabled={false}
          />
        </ModalFooter>
      </CenteredModal>
    </Fragment>
  );
};

ExitConfirmationModal.defaultProps = {
  title: 'EXIT_CONFIRMATION_TITLE',
  message: 'DOCUMENT_WILL_NOT_BE_SAVED',
  cancelText: 'NO_GO_BACK',
  discardText: 'YES_QUIT',
  submittingText: null,
};
ExitConfirmationModal.propTypes = {
  closeConfirmationModal: PropTypes.func.isRequired,
  confirmationModalIsOpen: PropTypes.bool.isRequired,
  title: PropTypes.string,
  message: PropTypes.string,
  cancelText: PropTypes.string,
  discardText: PropTypes.string,
  submittingText: PropTypes.string,
};

export default hot(module)(ExitConfirmationModal);




// WEBPACK FOOTER //
// ./src/components/ExitConfirmationModal/ExitConfirmationModal.jsx